module.exports = __webpack_public_path__ + "static/media/gl.90bb1a38.svg";